var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVacantLand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 83,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-11.9%",
    y: "-9.6%",
    width: "123.8%",
    height: "119.2%",
    filterUnits: "objectBoundingBox",
    id: "icon-vacant-land_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-vacant-land_svg__a)",
    transform: "translate(-56 -68)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0D694D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.091 79.629h-3.903c-1.21 0-2.188-.89-2.188-1.989 0-1.005.827-1.828 1.897-1.96.322-1.526 1.8-2.68 3.574-2.68.11 0 .219.005.322.017 1.41.11 2.578.95 3.07 2.104a3.03 3.03 0 011.763-.779",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.99 80.457c0 1.829-1.635 3.315-3.647 3.315h-13.13c-1.611 0-2.918-1.188-2.918-2.651 0-.553.188-1.067.51-1.492.523-.702 1.405-1.16 2.408-1.16.127 0 .243.022.365.033v-.033c0-1.265.486-2.425 1.3-3.337.146-.165.304-.326.474-.475a6.024 6.024 0 011.982-1.143 6.275 6.275 0 012.079-.348c1.781 0 3.374.729 4.444 1.872a3.098 3.098 0 011.757-.547c1.61 0 2.918 1.188 2.918 2.652 0 .21-.037.414-.085.613.93.602 1.544 1.586 1.544 2.701z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0D694D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.759 83.553c4.495 0 8.138 3.587 8.138 8.013 0 4.425-3.643 8.012-8.138 8.012s-8.138-3.587-8.138-8.012c0-4.426 3.643-8.013 8.138-8.013zM78.601 80.885V79M71.274 84.196l-1.353-1.332M67.913 92.19H66M71.274 100.186l-1.353 1.332M86.566 84.196l1.353-1.332M89.928 92.19h1.913M86.566 100.186l1.353 1.332M78.601 101.935v1.884"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150 138.638c0 2.561-20.149 4.637-45 4.637-24.854 0-45-2.076-45-4.637 0-2.562 20.146-4.638 45-4.638 24.851 0 45 2.076 45 4.638",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0D694D",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.71 129.11c0 2.53-2.711 4.588-4.856 4.588S136 131.64 136 129.11c0-2.529 4.854-9.11 4.854-9.11s4.856 6.581 4.856 9.11z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.854 133.698v4.068",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0D694D",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.71 129.11c0 2.53-2.711 4.588-4.856 4.588S66 131.64 66 129.11c0-2.529 4.854-9.11 4.854-9.11s4.856 6.581 4.856 9.11z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.854 133.698v4.068",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0D694D",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.42 113.697c0 5.192-5.423 9.415-9.712 9.415-4.29 0-9.708-4.223-9.708-9.415 0-5.19 9.708-18.697 9.708-18.697s9.713 13.507 9.713 18.697z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.707 123.113v14.457",
    strokeLinecap: "round"
  })))));
}
export default SvgIconVacantLand;